import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { BoardPage } from './canvas/BoardPage';
import { HomePage } from './home/HomePage';
import { ProjectPage } from './dev/ProjectPage';
import { StyleGuidePage } from './dev/StyleGuidePage';
import { AppHeader } from './components/AppHeader';
import { ThemeProvider } from './styles/theme';

const isDev = import.meta.env.DEV;

export function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="h-full w-full flex flex-col bg-bg-app text-fg-primary">
          <AppHeader />
          <main className="flex-1 min-h-0 relative">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/b/:boardId" element={<BoardPage />} />
              {isDev && <Route path="/project" element={<ProjectPage />} />}
              {isDev && <Route path="/style-guide" element={<StyleGuidePage />} />}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}
